// Module
var code = `<!-- 12. Buttons -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Buttons</span>
    <span class="jumbotron-note">One blue: every button reads --jumbotron-primary and --jumbotron-primary-ink. One primary button per surface. Use the small size everywhere in a workspace. Give every icon-only button an aria-label.</span>
  </div>
  <div class="style-guide-body">
    <div class="style-guide-row-samples">
      <div class="style-guide-sample" ng-repeat="button in \$ctrl.buttons track by button.className">
        <button type="button" ng-class="button.className">{{ button.label }}</button>
        <code class="style-guide-caption">{{ button.className }}</code>
        <span class="jumbotron-note">{{ button.use }}</span>
      </div>
      <div class="style-guide-sample">
        <button type="button" class="btn-close" aria-label="Close the panel"></button>
        <code class="style-guide-caption">btn-close</code>
        <span class="jumbotron-note">Closes a panel.</span>
      </div>
      <div class="style-guide-sample">
        <button type="button" class="btn btn-sm btn-outline-secondary" aria-label="Edit the playlist">
          <i class="fas fa-pencil" aria-hidden="true"></i>
        </button>
        <code class="style-guide-caption">btn btn-sm btn-outline-secondary</code>
        <span class="jumbotron-note">An icon-only button. The aria-label names the action.</span>
      </div>
    </div>
  </div>
</div>

<!-- 13. Form controls -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Form controls</span>
    <span class="jumbotron-note">A date and a time stand beside each other. The app does not use datetime-local.</span>
  </div>
  <div class="style-guide-body">
    <div class="style-guide-row-samples">
      <div class="style-guide-sample">
        <input type="text" class="form-control form-control-sm style-guide-input" aria-label="Name of the playlist"
          value="o_thursday_general">
        <code class="style-guide-caption">form-control form-control-sm</code>
      </div>
      <div class="style-guide-sample">
        <span class="jumbotron-field-label">From</span>
        <span class="style-guide-pair">
          <input type="date" class="form-control form-control-sm style-guide-date" aria-label="From date"
            value="2026-07-03">
          <input type="time" class="form-control form-control-sm style-guide-time" aria-label="From time"
            value="12:00">
        </span>
        <code class="style-guide-caption">type=date and type=time</code>
      </div>
      <div class="style-guide-sample">
        <select class="form-select form-select-sm style-guide-select" aria-label="Scene">
          <option>All scenes</option>
          <option>Orange</option>
          <option>Arena</option>
        </select>
        <code class="style-guide-caption">form-select form-select-sm</code>
      </div>
      <div class="style-guide-sample">
        <input type="search" class="form-control form-control-sm style-guide-search" aria-label="Search"
          placeholder="Search">
        <code class="style-guide-caption">type=search</code>
      </div>
    </div>
  </div>
</div>

<!-- 14. Menu -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Menu</span>
    <span class="jumbotron-note">A right-click opens this menu at the cursor. The code in
      client/common/context-menu.js builds it. An entry is a command or a check item.</span>
  </div>
  <div class="style-guide-body">
    <div class="style-guide-row-samples">
      <div class="style-guide-sample">
        <div class="jumbotron-menu" role="menu">
          <button type="button" class="jumbotron-menu-item" role="menuitem">
            <i class="fas fa-pen" aria-hidden="true"></i>
            <span class="jumbotron-menu-label">Edit</span>
          </button>
          <button type="button" class="jumbotron-menu-item is-checked" role="menuitemcheckbox"
            aria-checked="true">
            <i class="fas fa-check jumbotron-menu-check" aria-hidden="true"></i>
            <span class="jumbotron-dot" ng-style="{ 'background-color': \$ctrl.sampleColours[0] }"></span>
            <span class="jumbotron-menu-label">Reklame</span>
          </button>
          <button type="button" class="jumbotron-menu-item" role="menuitemcheckbox" aria-checked="false">
            <i class="fas fa-check jumbotron-menu-check" aria-hidden="true"></i>
            <span class="jumbotron-dot" ng-style="{ 'background-color': \$ctrl.sampleColours[1] }"></span>
            <span class="jumbotron-menu-label">Orange TV</span>
          </button>
        </div>
        <code class="style-guide-caption">.jumbotron-menu &middot; .jumbotron-menu-item &middot;
          .jumbotron-menu-item.is-checked &middot; .jumbotron-menu-check &middot;
          .jumbotron-menu-label</code>
        <span class="jumbotron-note">The colour of a label is data, so the code sets the dot inline. The
          open menu adds <code>.jumbotron-menu-floating</code>, which holds the fixed position and the
          layer. This sample leaves that class out and stands in the page.</span>
      </div>
    </div>
  </div>
</div>

<!-- 15. Dialog -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Dialog</span>
    <span class="jumbotron-note">A card above a dimmed page, for a task the operator finishes and leaves. The
      element is the native dialog, so the browser owns the top layer, the backdrop, the focus trap and the
      Escape key. The directive in client/common/jumbotron-dialog.directive.js opens it from one flag, and it
      closes the dialog on Escape and on a click on the dimmed page.</span>
  </div>
  <div class="style-guide-body">
    <div class="style-guide-row-samples">
      <div class="style-guide-sample">
        <dialog class="style-guide-dialog" open aria-labelledby="style-guide-dialog-heading">
          <div class="jumbotron-panel-head">
            <h2 class="jumbotron-heading" id="style-guide-dialog-heading">Delete the playlist</h2>
            <button type="button" class="btn-close" aria-label="Close"></button>
          </div>
          <div class="jumbotron-dialog-body">
            <span class="jumbotron-note">o_thursday_general holds 14 items and it is scheduled on Orange on
              Thursday. Deleting it removes the schedule as well.</span>
          </div>
          <div class="jumbotron-dialog-foot">
            <button type="button" class="btn btn-sm btn-outline-secondary">Cancel</button>
            <button type="button" class="btn btn-sm btn-discreet-danger">Delete</button>
          </div>
        </dialog>
        <code class="style-guide-caption">.jumbotron-dialog &middot; .jumbotron-panel-head &middot;
          .jumbotron-dialog-body &middot; .jumbotron-dialog-foot</code>
        <span class="jumbotron-note">The head is the panel head of every panel, with a
          <code>btn-close</code>. The body scrolls and the head and the foot stay in view. The foot is right
          aligned, and the action that changes something is the last button.</span>
        <span class="jumbotron-note">This sample is a real dialog with the <code>open</code> attribute, so it
          stands in the page. A closed dialog is not drawn, and the browser draws the dimmed page only for a
          dialog that showModal() opened. The sample therefore shows no backdrop.
          <code>.style-guide-dialog</code> calls the card mixin of the element without the placement that a
          modal takes.</span>
      </div>
    </div>
  </div>
</div>
`;
// Exports
export default code;